document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;

  const header = toggle.closest('[data-header]');
  const isOpen = header.getAttribute('data-menu-open') === 'true';
  header.setAttribute('data-menu-open', String(!isOpen));
  toggle.setAttribute('aria-expanded', String(!isOpen));
});

const ageGate = document.querySelector('[data-age-gate]');

if (ageGate) {
  const storageKey = 'wbmsAgeConfirmed';
  const confirmButton = ageGate.querySelector('[data-age-confirm]');
  const declineButton = ageGate.querySelector('[data-age-decline]');

  const hasConfirmedAge = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return document.cookie.split('; ').includes(`${storageKey}=true`);
    }
  };

  const setConfirmedAge = () => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      document.cookie = `${storageKey}=true; path=/; max-age=31536000; samesite=lax`;
    }
  };

  if (!hasConfirmedAge()) {
    ageGate.hidden = false;
    document.documentElement.classList.add('age-gate-open');
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(() => confirmButton?.focus(), 0);
  }

  confirmButton?.addEventListener('click', () => {
    setConfirmedAge();
    ageGate.hidden = true;
    document.documentElement.classList.remove('age-gate-open');
    document.documentElement.style.overflow = '';
  });

  declineButton?.addEventListener('click', () => {
    const fallback = 'https://www.google.com';
    window.location.href = ageGate.dataset.ageRedirect || fallback;
  });
}

document.addEventListener('submit', (event) => {
  const bottleCartForm = event.target.closest('.product-form--bottle-cart');
  if (!bottleCartForm) return;

  const selectedOption = bottleCartForm.querySelector('input[name="pack_option"]:checked');
  const itemsJson = selectedOption?.dataset.cartItems;
  if (!itemsJson) return;

  event.preventDefault();

  let items;
  try {
    items = JSON.parse(itemsJson);
  } catch (error) {
    window.alert('Sorry, this pack option could not be added. Please refresh and try again.');
    return;
  }

  const submitButton = event.submitter || bottleCartForm.querySelector('button[type="submit"]');
  const originalButtonText = submitButton?.textContent;
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  })
    .then(async (response) => {
      if (response.ok) return response.json();
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload.description || payload.message || 'Unable to add this option to cart.');
    })
    .then(() => {
      window.location.href = '/cart';
    })
    .catch((error) => {
      window.alert(error.message);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText || 'Add selected option';
      }
    });
});

document.addEventListener('submit', (event) => {
  const cartForm = event.target.closest('.cart-form');
  if (!cartForm || event.submitter?.name !== 'checkout') return;

  const dobInput = cartForm.querySelector('#CartDateOfBirth');
  if (!dobInput) return;

  const birthDate = new Date(`${dobInput.value}T00:00:00`);
  const minimumDate = new Date();
  minimumDate.setFullYear(minimumDate.getFullYear() - 18);
  minimumDate.setHours(23, 59, 59, 999);

  dobInput.setCustomValidity('');

  if (!dobInput.value || Number.isNaN(birthDate.getTime()) || birthDate > minimumDate) {
    event.preventDefault();
    dobInput.setCustomValidity('You must be 18 years or over to purchase wine.');
    dobInput.reportValidity();
  }
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-carousel-target]');
  if (!thumb) return;

  const carousel = thumb.closest('[data-product-carousel]');
  const target = carousel?.querySelector(`#${thumb.dataset.carouselTarget}`);
  if (!target) return;

  target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  carousel.querySelectorAll('.product-thumb').forEach((button) => button.classList.remove('is-active'));
  thumb.classList.add('is-active');
});

document.addEventListener('click', (event) => {
  const zoomTrigger = event.target.closest('[data-product-zoom]');
  if (!zoomTrigger) return;

  const productMedia = zoomTrigger.closest('.product-media');
  const modal = productMedia?.querySelector('[data-product-zoom-modal]');
  const modalImage = modal?.querySelector('[data-product-zoom-image]');
  if (!modal || !modalImage) return;

  const image = zoomTrigger.querySelector('img');
  modalImage.src = zoomTrigger.dataset.productZoom;
  modalImage.alt = image?.alt || 'Product image';
  modal.hidden = false;
  document.documentElement.style.overflow = 'hidden';
});

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-product-zoom-close]');
  const modal = closeButton ? closeButton.closest('[data-product-zoom-modal]') : event.target.closest('[data-product-zoom-modal]');
  if (!modal || (event.target !== modal && !closeButton)) return;

  modal.hidden = true;
  const modalImage = modal.querySelector('[data-product-zoom-image]');
  if (modalImage) modalImage.removeAttribute('src');
  document.documentElement.style.overflow = '';
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const modal = document.querySelector('[data-product-zoom-modal]:not([hidden])');
  if (!modal) return;

  modal.hidden = true;
  const modalImage = modal.querySelector('[data-product-zoom-image]');
  if (modalImage) modalImage.removeAttribute('src');
  document.documentElement.style.overflow = '';
});

document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('.hero-image'));
  if (slides.length < 2) return;

  let index = 0;
  window.setInterval(() => {
    slides[index].classList.remove('is-active');
    index = (index + 1) % slides.length;
    slides[index].classList.add('is-active');
  }, 4500);
});

const revealSelectors = [
  '.section-heading',
  '.page-heading',
  '.wine-card',
  '.story-image-wrap',
  '.story-content',
  '.about-feature__media',
  '.about-feature__content',
  '.product-media',
  '.product-summary',
  '.policy-grid article',
  '.faq-list details',
  '.contact-card',
  '.site-footer'
];

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealItems = Array.from(document.querySelectorAll(revealSelectors.join(',')));

revealItems.forEach((item, index) => {
  if (item.hasAttribute('data-scroll-reveal')) return;

  const revealType = item.matches('.wine-card, .policy-grid article, .faq-list details') ? 'card' : item.matches('.story-image-wrap, .about-feature__media, .product-media') ? 'image' : 'text';
  item.setAttribute('data-scroll-reveal', revealType);

  const groupIndex = item.matches('.wine-card, .policy-grid article, .faq-list details') ? index % 4 : 0;
  item.style.setProperty('--scroll-delay', `${Math.min(groupIndex * 90, 270)}ms`);
});

if (prefersReducedMotion || !('IntersectionObserver' in window)) {
  revealItems.forEach((item) => item.classList.add('is-visible'));
} else {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  revealItems.forEach((item) => revealObserver.observe(item));
}
